import { Know } from 'interfaces/Know'
import {
    AnalyticsEventKnowContentDuration10,
    AnalyticsEventKnowContentDuration120,
    AnalyticsEventKnowContentDuration15,
    AnalyticsEventKnowContentDuration30,
    AnalyticsEventKnowContentDuration5,
    AnalyticsEventKnowContentDuration60,
    AnalyticsEventKnowContentDuration90,
} from 'lib/constants/AnalyticsEventType'
import { getReferrerScreen } from 'lib/formatting/url'
import { trackEvent } from 'lib/tracking/analytics-service'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

interface Props {
    know: Know
}

const KnowContentDurationTracking = ({ know }: Props) => {
    const router = useRouter()
    const referrerScreen = getReferrerScreen(router)

    const trackDuration = (event: string, durationIsSeconds: number) =>
        trackEvent(event, { valueId: durationIsSeconds, know, referrerScreen })

    const handleDurationTracking = (durationIsSeconds: number) => {
        switch (true) {
            case durationIsSeconds === 5:
                trackDuration(AnalyticsEventKnowContentDuration5, 5)
                break
            case durationIsSeconds === 10:
                trackDuration(AnalyticsEventKnowContentDuration10, 10)
                break
            case durationIsSeconds === 15:
                trackDuration(AnalyticsEventKnowContentDuration15, 15)
                break
            case durationIsSeconds === 30:
                trackDuration(AnalyticsEventKnowContentDuration30, 30)
                break
            case durationIsSeconds === 60:
                trackDuration(AnalyticsEventKnowContentDuration60, 60)
                break
            case durationIsSeconds === 90:
                trackDuration(AnalyticsEventKnowContentDuration90, 90)
                break
            case durationIsSeconds === 120:
                trackDuration(AnalyticsEventKnowContentDuration120, 120)
                break
        }
    }

    useEffect(() => {
        let i = 0
        const interval = setInterval(() => {
            i += 5
            handleDurationTracking(i)
            if (i === 120) {
                clearInterval(interval)
            }
        }, 5000)

        return () => {
            clearInterval(interval)
        }
    }, [])

    return <></>
}

export default KnowContentDurationTracking
